var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck, "_classCallCheck");
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
__name(_defineProperties, "_defineProperties");
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: false }), e;
}
__name(_createClass, "_createClass");
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
__name(_callSuper, "_callSuper");
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
__name(_possibleConstructorReturn, "_possibleConstructorReturn");
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
__name(_assertThisInitialized, "_assertThisInitialized");
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct = /* @__PURE__ */ __name(function _isNativeReflectConstruct2() {
    return !!t;
  }, "_isNativeReflectConstruct"))();
}
__name(_isNativeReflectConstruct, "_isNativeReflectConstruct");
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t2) {
    return t2.__proto__ || Object.getPrototypeOf(t2);
  }, _getPrototypeOf(t);
}
__name(_getPrototypeOf, "_getPrototypeOf");
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf(t, e);
}
__name(_inherits, "_inherits");
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t2, e2) {
    return t2.__proto__ = e2, t2;
  }, _setPrototypeOf(t, e);
}
__name(_setPrototypeOf, "_setPrototypeOf");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
import React, { Component } from "react";
import debounce from "lodash/debounce";
import ClassNames from "classnames";
import { ArrowUpLightIcon } from "@riseart/icons";
import { scrollTopBtnCls, scrollTopFixedBtnCls, scrollTopActiveBtnCls, scrollTopBtnContainerCls, totalButtonOffset } from "./Button.less";
var DEBOUNCE_DELAY_MS = 10;
var buttonHeightAndPositionSum = parseInt(totalButtonOffset, 10);
var ScrollToTopButton = /* @__PURE__ */ function(_Component) {
  function ScrollToTopButton2(props) {
    var _this;
    _classCallCheck(this, ScrollToTopButton2);
    _this = _callSuper(this, ScrollToTopButton2, [props]);
    _defineProperty(_this, "wasComponentUnmounted", false);
    _this.bindMethods();
    _this.buttonRef = /* @__PURE__ */ React.createRef();
    _this.wrapperRef = /* @__PURE__ */ React.createRef();
    _this.state = {
      intervalId: 0,
      isVisible: false,
      isFixedPositioned: false
    };
    return _this;
  }
  __name(ScrollToTopButton2, "ScrollToTopButton");
  _inherits(ScrollToTopButton2, _Component);
  return _createClass(ScrollToTopButton2, [{
    key: "bindMethods",
    value: /* @__PURE__ */ __name(function bindMethods() {
      this.scrollToTop = this.scrollToTop.bind(this);
      this.scrollStep = this.scrollStep.bind(this);
      this.toggleScrollComponent = debounce(this.toggleScrollComponent.bind(this), DEBOUNCE_DELAY_MS);
    }, "bindMethods")
    /**
     * componentDidMount
     */
  }, {
    key: "componentDidMount",
    value: /* @__PURE__ */ __name(function componentDidMount() {
      this.wasComponentUnmounted = false;
      this.setState({
        isFixedPositioned: this.setButtonPosition()
      });
      window.addEventListener("scroll", this.toggleScrollComponent);
    }, "componentDidMount")
    /**
     * componentWillUnmount
     */
  }, {
    key: "componentWillUnmount",
    value: /* @__PURE__ */ __name(function componentWillUnmount() {
      this.wasComponentUnmounted = true;
      window.removeEventListener("scroll", this.toggleScrollComponent);
    }, "componentWillUnmount")
    /**
     * toggleScrollComponent
     */
  }, {
    key: "toggleScrollComponent",
    value: /* @__PURE__ */ __name(function toggleScrollComponent() {
      if (this.wasComponentUnmounted || !this.buttonRef.current || !this.wrapperRef.current) {
        return;
      }
      this.setState({
        isFixedPositioned: this.setButtonPosition(),
        isVisible: window.pageYOffset / window.screen.availHeight > this.props.visibilityScreenPos
      });
    }, "toggleScrollComponent")
    /**
     * setButtonPosition
     *
     * @returns {boolean}
     */
  }, {
    key: "setButtonPosition",
    value: /* @__PURE__ */ __name(function setButtonPosition() {
      var buttonRect = this.buttonRef.current.getBoundingClientRect();
      var wrapperRect = this.wrapperRef.current.getBoundingClientRect();
      var isButtonHigherThanWrapper = buttonRect.bottom >= wrapperRect.bottom;
      var isWrapperBellowFixedLine = wrapperRect.y + buttonHeightAndPositionSum <= window.innerHeight;
      return isButtonHigherThanWrapper && this.state.isVisible && isWrapperBellowFixedLine;
    }, "setButtonPosition")
    /**
     * scrollStep
     */
  }, {
    key: "scrollStep",
    value: /* @__PURE__ */ __name(function scrollStep() {
      if (window.pageYOffset === 0) {
        clearInterval(this.state.intervalId);
      }
      window.scroll(0, window.pageYOffset - this.props.scrollStep);
    }, "scrollStep")
    /**
     * scrollToTop
     */
  }, {
    key: "scrollToTop",
    value: /* @__PURE__ */ __name(function scrollToTop() {
      var intervalId = setInterval(this.scrollStep, this.props.delay);
      this.setState({
        intervalId
      });
    }, "scrollToTop")
    /**
     * render
     */
  }, {
    key: "render",
    value: /* @__PURE__ */ __name(function render() {
      return /* @__PURE__ */ React.createElement("div", {
        className: scrollTopBtnContainerCls,
        ref: this.wrapperRef
      }, /* @__PURE__ */ React.createElement("button", {
        type: "button",
        onClick: this.scrollToTop,
        className: ClassNames(scrollTopBtnCls, _defineProperty(_defineProperty({}, scrollTopActiveBtnCls, this.state.isVisible), scrollTopFixedBtnCls, !this.state.isFixedPositioned)),
        ref: this.buttonRef
      }, /* @__PURE__ */ React.createElement(ArrowUpLightIcon, null)));
    }, "render")
  }]);
}(Component);
_defineProperty(ScrollToTopButton, "defaultProps", {
  scrollStep: 500,
  delay: 5,
  visibilityScreenPos: 1.5
});
export {
  ScrollToTopButton
};
